<template>
  <hic-dialog append-to-body :close-on-click-modal="false" :visible="visible" width="50rem" @open="open" :title="entity.id ? '编辑班次' : '新建班次'" @close="cancel">
    <el-form :model="entity" :rules="rules" ref="editor" label-width="6rem">
      <el-form-item label="班次名称" prop="name">
        <el-input v-model.trim="entity.name" placeholder="请输入班次名称"></el-input>
      </el-form-item>
      <el-form-item label="颜色标识" prop="color">
        <el-color-picker v-model="entity.color" :predefine="predefineColors"></el-color-picker>
      </el-form-item>
      <el-form-item label="工作量(天)" prop="workload">
        <el-input-number v-model="entity.workload" :min="0" :max="10" :step="0.5" label="工作量天数" style="width: 150px;"></el-input-number>
      </el-form-item>
      <el-form-item label="是否禁用" prop="disabled">
        <el-switch v-model="entity.disabled" active-text="禁用" inactive-text="启用"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="save" :loading="saving">确 定</el-button>
    </div>
  </hic-dialog>
</template>

<script>
import api from '@/common/api'

export default {
  props: {
    visible: Boolean,
    entity: Object
  },
  data() {
    return {
      saving: false,
      rules: {
        name: [
          { required: true, message: '请输入班次名称', trigger: 'blur' },
          { max: 20, message: '名称长度在 20 个字符以内', trigger: 'blur' }
        ],
        color: [
          { required: true, message: '请选择颜色标识', trigger: 'change' }
        ],
        workload: [
          { required: true, message: '请输入工作量', trigger: 'blur' }
        ]
      },
      predefineColors: [
        '#c8f0d8', '#c8dff0', '#f0ecc8', '#d4f0c8', '#e0f0e0',
        '#c8f0e8', '#f0d0c8', '#f0c8d8', '#e0e0e0', '#d8c8f0',
        '#f0c8c8', '#f0e0c8', '#ffffff'
      ]
    }
  },
  methods: {
    open() {
      // Form reset if necessary
      if (this.$refs.editor) {
        this.$refs.editor.clearValidate()
      }
    },
    cancel() {
      this.$emit('update:visible', false)
    },
    save() {
      this.$refs.editor.validate((valid) => {
        if (valid) {
          this.saving = true
          api.ShiftType.save(this.entity).then(res => {
            this.$message.success('保存成功')
            this.$emit('update:visible', false)
            this.$emit('ok', res)
          }).catch(err => {
            this.$message.error('保存失败: ' + err)
          }).finally(() => {
            this.saving = false
          })
        }
      })
    }
  }
}
</script>
